<template>
  <div class="bg-white mAll10">
    <el-button class="export-btn" type="primary" size="mini" @click="daochu">{{
      $t("components.report.reportTemp.51h4zykhihw0")
    }}</el-button>
    <div class="flex-sb pl20 pr20 pt10">
      <!-- 筛选条件 -->
      <slot></slot>
    </div>
    <div class="content-page-box bg-white">
      <div class="tableDiv-report" ref="auto_height_table">
        <reportTableCont
          @handleColumnChange="handleColumnChange"
          :tableData="tableList"
          @handSetting="handSetting"
        ></reportTableCont>
        <!-- 分页 -->
        <el-pagination
          style="margin: 10px;"
          :current-page.sync="paging.curPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="paging.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="paging.pageTotal"
          @current-change="curPageChange"
          @size-change="pageSizeChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import reportTableCont from "@/components/tables/reportTableCont";
import storeReport from "@/views/Report/analysisreport";
import {isGraySchoolEnabled} from "@/bootstrap/graySchoolRouting";
export default {
  name: "ReportTemp-reportType",
  props: ["reportParams", "filter"],
  data() {
    return {
      wayProp: "", //方法名
      // 表格数据
      tableList: {
        // 表格的列
        columns: [],
        // 表格数据
        list: [],
        options: {
          errortip: "", //空页面提示内容
          mutiSelect: false, //是否显示多选
          issetting: true, //是否可以编辑列
          tableHeight: 0,
          // showSummary:false,//是否总计
          moduleName: "Report", //当前页面所属于模块的名称****一个模块是唯一的
          ColumnName: "", //当前页面的名称，通常与路由名称一致
        },
      },
      // 分页
      paging: {
        curPage: 1,
        pageSize: 10,
        pageTotal: 0,
      },
    };
  },
  components: {
    reportTableCont,
  },
  updated() {},
  created() {
    // this.token = this.$store.state.USER_TOKEN;
    // this.staffer_id = this.$store.state.STAFFER_ID;
    // this.school_id = this.$store.state.SCHOOL_ID;
    // this.company_id = this.$store.state.COMPANY_ID;
    // this.re_postbe_id = this.$userInfo.re_postbe_id;
    // this.power_postrole_id = this.$userInfo.POSTROLE_ID;
    this.languageType = this.$Tool.getStorage("language")
      ? this.$Tool.getStorage("language")
      : "zh";
    this.tableList.options.ColumnName = this.reportParams.wayString;
    this.Analysisreport(); //报表列表及导出报表
  },
  methods: {
    //报表列表及导出报表
    Analysisreport() {
      let baseObj = {
        is_count: "1", //是否需要总数，可以不传
        p: this.paging.curPage,
        num: this.paging.pageSize,
      };

      let obj = Object.assign(baseObj, this.filter);
      delete obj.rang_time;
      // if (typeof obj.frommedia_name != "string") {
      //   obj.frommedia_name = JSON.stringify(obj.frommedia_name);
      // }
      if(isGraySchoolEnabled()){
        if(obj.channel_id && obj.channel_id.length){
          // encode 编码
          obj.channel_id = encodeURIComponent(obj.channel_id);
        }
      }else{
        if (typeof obj.channel_id != "string") {
          obj.channel_id = JSON.stringify(obj.channel_id);
        }
      }

      storeReport[this.reportParams.wayString](obj).then((res) => {
        this.paging.pageTotal = parseInt(res.data.data.allnum);
        let obj = this.$Tool.getStorage(
          "module" + [this.tableList.options.moduleName]
        );
        if (obj) {
          if (obj["show_" + [this.tableList.options.ColumnName]]) {
            this.tableList.columns =
              obj["show_" + [this.tableList.options.ColumnName]];
          } else {
            this.tableList.columns = res.data.data.field;
          }
        } else {
          this.tableList.columns = res.data.data.field;
        }
        if (res.data.code === 200) {
          this.tableList.list = res.data.data.list
            ? res.data.data.list
            : [];
        } else {
          this.tableList.list = [];
          this.tableList.options.errortip = res.data.msg;
        }
      });
    },
    // 数据检索
    search() {
      this.paging.curPage = 1;
      this.Analysisreport(); //报表列表及导出报表
    },
    // 班组联动检索
    courseTypeSearch() {
      this.paging.curPage = 1;
      this.Analysisreport(); //报表列表及导出报表
    },
    // 点击表格内容
    handleColumnChange(v1, v2, v3) {
      this.$emit("handleColumnChange", v1, v2, v3);
    },
    // 编辑列编辑提交
    handSetting(v) {
      (() => {})(v)
      this.Analysisreport(); //报表列表及导出报表
    },
    // 导出操作
    daochu() {
      let params_str = "",
        is_export = 1;
      for (let name in this.filter) {
        if (name != "rang_time") {
          // 时间范围不需要
          if (typeof this.filter[name] == "string") {
            params_str = params_str + `&${name}=${this.filter[name] || ""}`;
          } else {
            if(isGraySchoolEnabled() && name == 'channel_id'){
              if(this.filter[name] && this.filter[name].length){
                // encode 编码
                params_str = params_str + `&${name}=${encodeURIComponent(this.filter[name].channel_id)}`;
              }
            }else{
              params_str =
                  params_str + `&${name}=${JSON.stringify(this.filter[name])}`;
            }

          }
        }
      }
      let url = storeReport[this.reportParams.wayString + "1"]();
      params_str = params_str = `${url}${this.$exportParameStr}&is_export=${is_export}${params_str}`;
      if (this.tableList.list.length > 0) {
        window.open(this.$buildExportUrl(params_str), "_blank");
      } else {
        this.$message.error(
          this.$t("components.report.reportTemp.51h4zykhk8o0")
        );
      }
    },
    // 页码变化
    curPageChange(v) {
      this.paging.curPage = v;
      this.Analysisreport(0); //分析报表列表及导出报表
    },
    // pageSize改变
    pageSizeChange(v) {
      (() => {})(v);
      this.paging.curPage = 1;
      this.Analysisreport(0); //分析报表列表及导出报表
    },
    handleClose(done) {
      done();
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs["auto_height_table"]) {
        this.tableList.options.tableHeight = this.$Tool.getTableHeight(
          this.$refs.auto_height_table.getBoundingClientRect().top + 52
        );
      }
    });
  },
};
</script>
<style lang="less"></style>
